import React from 'react'

import styles from '../../../styles'

const SvgCv = props => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="currentColor" {...props}>
    <text fontFamily={styles.fonts.primary.family} fontSize={18} fontWeight="bold">
      <tspan x={3} y={26}>
        {'CV+'}
      </tspan>
    </text>
  </svg>
)

export default SvgCv
